__turbopack_context__.v({
  "actions": "generator-module__MRFW_W__actions",
  "alt": "generator-module__MRFW_W__alt",
  "askChip": "generator-module__MRFW_W__askChip",
  "askHint": "generator-module__MRFW_W__askHint",
  "askOptions": "generator-module__MRFW_W__askOptions",
  "badge": "generator-module__MRFW_W__badge",
  "bdot": "generator-module__MRFW_W__bdot",
  "best": "generator-module__MRFW_W__best",
  "bl": "generator-module__MRFW_W__bl",
  "bot": "generator-module__MRFW_W__bot",
  "btn": "generator-module__MRFW_W__btn",
  "c-ai": "generator-module__MRFW_W__c-ai",
  "c-hand": "generator-module__MRFW_W__c-hand",
  "c-img": "generator-module__MRFW_W__c-img",
  "c-link": "generator-module__MRFW_W__c-link",
  "c-ok": "generator-module__MRFW_W__c-ok",
  "c-tg": "generator-module__MRFW_W__c-tg",
  "c-up": "generator-module__MRFW_W__c-up",
  "c-vid": "generator-module__MRFW_W__c-vid",
  "chat": "generator-module__MRFW_W__chat",
  "chatIn": "generator-module__MRFW_W__chatIn",
  "chatPad": "generator-module__MRFW_W__chatPad",
  "chip": "generator-module__MRFW_W__chip",
  "choice": "generator-module__MRFW_W__choice",
  "composer": "generator-module__MRFW_W__composer",
  "composerCompact": "generator-module__MRFW_W__composerCompact",
  "composerStack": "generator-module__MRFW_W__composerStack",
  "conn": "generator-module__MRFW_W__conn",
  "cta": "generator-module__MRFW_W__cta",
  "dim": "generator-module__MRFW_W__dim",
  "done": "generator-module__MRFW_W__done",
  "dot": "generator-module__MRFW_W__dot",
  "dotImg": "generator-module__MRFW_W__dotImg",
  "dotLogo": "generator-module__MRFW_W__dotLogo",
  "exList": "generator-module__MRFW_W__exList",
  "fade": "generator-module__MRFW_W__fade",
  "hide": "generator-module__MRFW_W__hide",
  "iconBtn": "generator-module__MRFW_W__iconBtn",
  "lbl": "generator-module__MRFW_W__lbl",
  "micErr": "generator-module__MRFW_W__micErr",
  "micPulse": "generator-module__MRFW_W__micPulse",
  "msg": "generator-module__MRFW_W__msg",
  "nbody": "generator-module__MRFW_W__nbody",
  "needs": "generator-module__MRFW_W__needs",
  "needsAccounts": "generator-module__MRFW_W__needsAccounts",
  "needsIntro": "generator-module__MRFW_W__needsIntro",
  "needsOurs": "generator-module__MRFW_W__needsOurs",
  "needsServer": "generator-module__MRFW_W__needsServer",
  "node": "generator-module__MRFW_W__node",
  "note": "generator-module__MRFW_W__note",
  "ns": "generator-module__MRFW_W__ns",
  "nt": "generator-module__MRFW_W__nt",
  "pickPulse": "generator-module__MRFW_W__pickPulse",
  "picking": "generator-module__MRFW_W__picking",
  "pill": "generator-module__MRFW_W__pill",
  "pillIco": "generator-module__MRFW_W__pillIco",
  "primary": "generator-module__MRFW_W__primary",
  "prompt": "generator-module__MRFW_W__prompt",
  "promptCompact": "generator-module__MRFW_W__promptCompact",
  "promptRec": "generator-module__MRFW_W__promptRec",
  "promptStack": "generator-module__MRFW_W__promptStack",
  "rail": "generator-module__MRFW_W__rail",
  "rec": "generator-module__MRFW_W__rec",
  "recTime": "generator-module__MRFW_W__recTime",
  "replay": "generator-module__MRFW_W__replay",
  "schema": "generator-module__MRFW_W__schema",
  "sel": "generator-module__MRFW_W__sel",
  "sell": "generator-module__MRFW_W__sell",
  "sellH": "generator-module__MRFW_W__sellH",
  "sellNote": "generator-module__MRFW_W__sellNote",
  "sellP": "generator-module__MRFW_W__sellP",
  "send": "generator-module__MRFW_W__send",
  "show": "generator-module__MRFW_W__show",
  "spin": "generator-module__MRFW_W__spin",
  "step": "generator-module__MRFW_W__step",
  "stopIcon": "generator-module__MRFW_W__stopIcon",
  "subhint": "generator-module__MRFW_W__subhint",
  "typing": "generator-module__MRFW_W__typing",
  "user": "generator-module__MRFW_W__user",
  "viz": "generator-module__MRFW_W__viz",
  "who": "generator-module__MRFW_W__who",
});
